export default __webpack_public_path__ + "static/media/gift_card.9f349ad8.svg";